import { AnchorHTMLAttributes, ReactNode } from 'react';

import './PrimaryLink.scss';

interface IPrimaryLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  readonly children: ReactNode;
}

export function PrimaryLink(props: IPrimaryLinkProps) {
  const { children, ...anchorProps } = props;

  return (
    <a {...anchorProps} className="pmi_web__PrimaryLink">
      {children}
    </a>
  );
}
